export const messagedetailOtherRouter = [
  {
    path: 'messages/all',
    name: 'messagesAll',
    title: '全部消息',
    component: () => import('@/views/gip/message/all.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/message/messagedetail.js